import React, { forwardRef } from 'react';

type DebugComponentProps = {
  typeName: string;
};

const DebugComponent = forwardRef<HTMLDivElement, DebugComponentProps>(
  ({ typeName, ...componentProps }, ref) => (
    <div style={{ border: '1px solid red', padding: '5px' }} ref={ref}>
      {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
      <h2>Missing component for type: &apos;{typeName}&apos;</h2>
      <p>
        {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
        Check your <code>typesMapper</code> in <code>BodyRenderer</code>{' '}
        component
      </p>
      <h3>Component&apos;s props:</h3>
      <pre style={{ overflow: 'hidden' }}>
        {JSON.stringify(componentProps, null, 2)}
      </pre>
    </div>
  )
);

export default DebugComponent;
